var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded d-flex justify-content-center status",style:(_vm.getColor(_vm.status))},[_vm._v(_vm._s(_vm.status.estado ? _vm.status.estado.nombre: 'Sin Estado'))])}
var staticRenderFns = []

export { render, staticRenderFns }